import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=22467e80&"
import script from "./NotificationsMenu.vue?vue&type=script&lang=ts&"
export * from "./NotificationsMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports